import { NotificationData } from "../NotificationData";

export class NotificationGeneralLinkData extends NotificationData {
  setup(data: any) {
    super.setup(data);
    this.type = NotificationData.types.GENERAL_LINK;

    if (data.notificationData) {
      this.redirectPath = typeof data.notificationData?.link === "string" ? data.notificationData?.link : "/";
    }
  }
}
